import * as React from "react";

function SvgLast(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...props}>
      <path d="M23 8l-10 8 10 8V8zM9 8h3v16H9z" fill="#fff" />
    </svg>
  );
}

export default SvgLast;
